import { render } from "./MyDraftPublications.vue.js?vue&type=template&id=48187903!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyDraftPublications.vue?vue&type=template&id=48187903"
import script from "./MyDraftPublications.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyDraftPublications.vue?vue&type=script&lang=js"
export * from "./MyDraftPublications.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyDraftPublications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/MyDraftPublications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48187903"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48187903', __exports__)) {
    api.reload('48187903', __exports__)
  }
  
  module.hot.accept("./MyDraftPublications.vue.js?vue&type=template&id=48187903!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyDraftPublications.vue?vue&type=template&id=48187903", () => {
    api.rerender('48187903', render)
  })

}


export default __exports__